import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { uploadBankStatementFile, UploadBankStatementResponseData } from '../query-api'

interface UseUploadBankStatementProps {
  onError?: (error: APIError) => void
  onSuccess?: (data: any) => void
}

export const useUploadBankStatement = (props: UseUploadBankStatementProps = {}) => {
  const { onError, onSuccess } = props || {}

  const { mutate: upload, isLoading: isUploading } = useMutation((file: File) => uploadBankStatementFile(file), {
    onError: (error: APIError) => {
      onError?.(error)
    },
    onSuccess: ({ data }: UploadBankStatementResponseData) => {
      onSuccess?.(data)
    },
  })

  return { upload, isUploading }
}
